class HeaderComponent extends HTMLElement {
  connectedCallback() {
    this.headerNav = this.querySelector('[data-header-nav]');
    this.headerWrapper = document.querySelector('.shopify-section-group-header-group');
    this.announcementBar = document.querySelector('.section-announcement-bar');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('search-toggle');
    this.popovers = this.querySelectorAll('[popover]');
    this.popoverTriggers = this.querySelectorAll('button[popovertarget]');

    if (this.headerWrapper) this.initScroll();
    this.initPopoverTriggers();
  }

  disconnectedCallback() {
    if (this.boundResize) window.removeEventListener('window:resize', this.boundResize);
    if (this.boundScroll) window.removeEventListener('window:scroll', this.boundScroll);
  }

  initScroll() {
    this.lastScrollTop = 0;
    this.request = null;
    this.timer = null;

    const announcementHeight = this.announcementBar?.offsetHeight || 0;
    this.scrollOffset = announcementHeight + this.offsetHeight;
    this.headerStart = announcementHeight;

    this.updateCSSVars();

    this.boundResize = () => this.updateCSSVars();
    this.boundScroll = () => this.handleScroll();

    window.addEventListener('window:resize', this.boundResize);
    window.addEventListener('window:scroll', this.boundScroll);
  }

  updateCSSVars() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    document.documentElement.style.setProperty('--header-nav-height', `${this.headerNav?.offsetHeight || 0}px`);
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar?.offsetHeight || 0}px`);
  }

  handleScroll() {
    const blockedClasses = ['main-menu-is-open', 'cart-drawer-is-open', 'search-is-open'];
    if (blockedClasses.some(cls => document.body.classList.contains(cls))) return;

    clearTimeout(this.timer);

    if (!this.request) {
      this.request = requestAnimationFrame(() => this.scrollAnimation());
    }

    this.timer = setTimeout(() => {
      cancelAnimationFrame(this.request);
      this.request = null;
    }, 50);
  }

  scrollAnimation() {
    const scrollTop = window.scrollY;
    const atBottom = scrollTop + window.innerHeight > document.body.clientHeight;

    if (!document.body.classList.contains('main-menu-is-open')) {
      if (atBottom || (scrollTop > this.lastScrollTop && scrollTop > this.scrollOffset)) {
        this.hide();
      }
      else if (scrollTop <= this.headerStart) {
        this.revealTop();
      }
      else if (scrollTop < this.lastScrollTop) {
        this.reveal();
      }
    }

    this.lastScrollTop = scrollTop;
    this.request = requestAnimationFrame(() => this.scrollAnimation());
  }

  initPopoverTriggers() {
    const useHover = !window.interestForElementSupported && document.documentElement.classList.contains('no-touch');

    this.popoverTriggers.forEach((trigger) => {
      const popover = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!popover) return;

      if (useHover) {
        let closeTimeout;

        const openPopover = () => {
          clearTimeout(closeTimeout);
          if (!popover.matches(':popover-open')) {
            popover.showPopover();
          }
        };

        const scheduleClose = () => {
          closeTimeout = setTimeout(() => {
            if (popover.matches(':popover-open')) {
              popover.hidePopover();
            }
          }, 100);
        };

        trigger.addEventListener('pointerenter', openPopover);
        trigger.addEventListener('pointerleave', scheduleClose);
        popover.addEventListener('pointerenter', () => clearTimeout(closeTimeout));
        popover.addEventListener('pointerleave', scheduleClose);
      }

      trigger.addEventListener('click', (event) => {
        if (popover.matches(':popover-open') && trigger.dataset?.url && trigger.dataset.url !== '#') {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = trigger.dataset.url;
        }
      });
    });
  }

  hide() {
    document.body.classList.add('header-hidden', 'header-sticky');
    document.body.classList.remove('main-menu-is-open');
    this.closeSearch();
    this.popovers.forEach(popover => popover.hidePopover());
  }

  reveal() {
    document.body.classList.add('header-sticky');
    document.body.classList.remove('header-hidden');
  }

  revealTop() {
    document.body.classList.remove('header-hidden', 'header-sticky');
  }

  closeSearch() {
    if (this.search?.classList.contains('header__search--is-active')) this.searchToggle?.remove();
  }
}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}